import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=67fcaeba&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fcaeba')) {
      api.createRecord('67fcaeba', component.options)
    } else {
      api.reload('67fcaeba', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=67fcaeba&", function () {
      api.rerender('67fcaeba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/Index.vue"
export default component.exports